import React from 'react'

const ApprovIcon = ({width, height}) => {
  return (
    <svg
      width={width || "40"}
      height={height || "40"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="39.5"
        height="39.5"
        rx="7.75"
        fill="#F3FFE6"
        stroke="#5DB500"
        stroke-width="0.5"
      />
      <circle cx="20" cy="20" r="12" fill="#5DB500" />
      <path
        d="M12.5303 20.9697C12.2374 20.6768 11.7626 20.6768 11.4697 20.9697C11.1768 21.2626 11.1768 21.7374 11.4697 22.0303L15.9697 26.5303C16.2626 26.8232 16.7374 26.8232 17.0303 26.5303L28.0303 15.5303C28.3232 15.2374 28.3232 14.7626 28.0303 14.4697C27.7374 14.1768 27.2626 14.1768 26.9697 14.4697L16.5 24.9393L12.5303 20.9697Z"
        fill="white"
      />
    </svg>
  );
}

export default ApprovIcon